import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'categoryFilter'
})
export class CategoryFilter implements PipeTransform {

	transform(value: any, args?: any): any {

		if (value==null) return null;

		if ( args > 0 ) {
			return value.filter( item => parseInt(item.category) == parseInt(args) );
		} else {
			return value;
		}

	}

}



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/pipes/category.filter.pipe.ts